import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneNumberInstance = PhoneNumberUtil.getInstance();

export const parsePhoneNumber = (phoneNumber: string): { prefix: string, phone: string } => {
  if (phoneNumber) {
    try {
      const parsedNumber = phoneNumberInstance.parseAndKeepRawInput(phoneNumber);
      return {
        prefix: parsedNumber.getCountryCode(),
        phone: parsedNumber.getNationalNumber(),
      };
    } catch (e) {
      console.warn(e);
    }
  }
  return { prefix: '', phone: '' };
};
